/**
 * Page de creation ou d'edition d'une question pour un user
 */
import {Box, Flex, Heading} from '@chakra-ui/react'
import React from 'react'
import {useQuestion} from '../../commons/api/hooks'
import {
  CreateQuestionInput,
  Question,
  UpdateQuestionInput,
} from '../../commons/types/API'
import {useAuthUserId, useCanUpdateMyQuestions} from '../../context/AuthContext'
import QuestionStudentForm from '../Forms/QuestionStudentForm'
import ModalContainer from 'react-modal-promise'
import {Container, Stack} from '../ui'
import {modalYesNoPromise} from '../Modals/YesNo'
import {useSaveQuestion} from '../../hooks/questionsActions'
import {useNavigate, useParams} from 'react-router-dom'
import {ROUTE_USER_FAQ_MYQUESTION} from '../../constantes'
import Restricted from '../../routes/common/Restricted'
type UserFaqVideoProps = {
  consultationId?: string
}

export const UserFaqVideoMyQuestion = ({consultationId}: UserFaqVideoProps) => {
  const {questionId} = useParams()
  const {question} = useQuestion(questionId ?? 'empty')
  const canUpdate = useCanUpdateMyQuestions(question as Question)
  const uid = useAuthUserId()
  const isEdit = questionId ? true : false

  const navigate = useNavigate()
  const {handleSaveQuestion, isLoading, isSuccess} = useSaveQuestion({
    isEdit,
  })

  React.useEffect(() => {
    if (isSuccess) {
      navigate(`${ROUTE_USER_FAQ_MYQUESTION}`)
    }
  }, [isSuccess, navigate])

  const handleSubmit = (values: UpdateQuestionInput & CreateQuestionInput) => {
    openPopupConfirmSave(values)
  }
  const handleClose = () => {
    navigate(-1)
  }

  const openPopupConfirmSave = React.useCallback(
    (values: UpdateQuestionInput & CreateQuestionInput) => {
      //todo : gerer le libellé : create / update
      modalYesNoPromise({
        title: 'Confirmer',
        confirmLabel: 'Sauvegarder',
        children: (
          <Flex flexDirection={'column'}>
            <Heading>Envoyer la question</Heading>
            <hr />
            <Box>
              Souhaitez-vous vraiment envoyer la question <br />
              <strong>{values.title}</strong> <br />
              Vous ne pourrez plus la modifier par la suite.
            </Box>
          </Flex>
        ),
      })
        .then(ok => {
          handleSaveQuestion(values)
        })
        .catch(error => {
          console.error(error)
        })
    },
    [handleSaveQuestion],
  )

  if (question && !canUpdate) {
    return (
      <Restricted message="Vous ne pouvez pas modifier cette question"></Restricted>
    )
  }
  return (
    <>
      <Container variant="generalBg">
        <Stack spacing={4} mb={5}>
          <Heading>
            {isEdit ? 'Modifier ma question' : 'Poser une question'}
          </Heading>
        </Stack>

        <QuestionStudentForm
          isEdit={isEdit}
          onSubmit={handleSubmit}
          onClose={handleClose}
          initialValues={{
            questionCategoryId: question?.category?.id,
            questionAnswerId: question?.answer?.id,
            tagsData: question?.tags?.items,
            ...(question as Question),
            //this pattern or inside the form ?
            questionAuthorId: (question?.author?.id as string) ?? uid,
          }}
          isLoading={isLoading}
        />
      </Container>
      <ModalContainer />
    </>
  )
}

export default UserFaqVideoMyQuestion
